/**
 * Gets the base LotGPT URL (no path) for the deployment environment.
 * @param env - The deployment environment, e.g. `import.meta.env.VITE_APP_DEPLOY_ENV`
 * @returns The base LotGPT URL; production for any other environment
 */
export function getLotGptBaseUrl(env?: string): string {
  if (env === 'development') {
    return 'https://dev.lotgpt.com';
  } else if (env === 'staging') {
    return 'https://stg.lotgpt.com';
  }
  return 'https://lotgpt.com';
}
